<template>
  <div class="dialog-user-edit">
    <Modal
      v-model="showDialogs"
      :title="modelTitle"
      v-if="showDialogs"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <Form :model="menuMsg" :label-width="100" ref="editMenuForm" class="menu-edit">
        <FormItem label="菜单名：" prop="name" :rules="[{required: true, message: '菜单名不能为空', trigger: 'blur'}, { type: 'string', max: 15, message: '文本不能多余15个字符', trigger: 'blur'}]">
          <Input :maxlength="14" v-model="menuMsg.name" :autofocus="true" placeholder="请输入菜单名"></Input>
        </FormItem>
        <FormItem label="name：" prop="url" :rules="[{required: true, message: 'name不能为空', trigger: 'blur'}, { type: 'string', max: 29, message: '文本不能多余30个字符', trigger: 'blur'}]">
          <Input :maxlength="29" v-model="menuMsg.url" placeholder="请输入name"></Input>
        </FormItem>
        <FormItem label="图标标签：" prop="icon">
          <IconPicker :icon-value="menuMsg.icon" @updateIcon="updateIcon"></IconPicker>
        </FormItem>
        <FormItem label="授权：" prop="perms">
          <Input type="textarea" v-model="menuMsg.perms" placeholder="" :autosize="{minRows: 1,maxRows: 8}"></Input>
        </FormItem>
        <FormItem label="菜单级别：" prop="type" :rules="{required: true, message: '菜单级别不能为空', trigger: 'blur'}">
          <Select v-model="menuMsg.type" @on-change="postMenuFilter(menuMsg.parentName)">
            <Option value="0">一级目录</Option>
            <Option value="1">二级目录</Option>
            <Option value="2">按钮</Option>
          </Select>
        </FormItem>
        <FormItem v-if="menuMsg.type==1||menuMsg.type==2" label="上级菜单：" prop="parentId" :rules="{required: true, message: '上级菜单不能为空', trigger: 'blur'}">
          <Select
              v-model="menuMsg.parentId"
              filterable
          >
            <Option v-for="(option, index) in parentMenuList" :value="option.value" :key="index">{{option.label}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
import IconPicker from '../../../components/elements/iconPicker'
export default {
  components: {IconPicker},
  props: {
    query: '', // menu id
    showDialogs: false,
    modelTitle: ''
  },
  data () {
    return {
      menuMsg: { // form表单的属性值
        name: '',
        url: '',
        icon: '',
        perms: '',
        type: '0',
        parentId: '',
        parentName: ''
      },
      defaultMenu: {}, // 对象的默认值，做比对用
      formLoading: true, // 表单的loading状态
      parentMenuLoading: false, // 下拉模糊查询loading状态
      allMenuList: [], // 所有的menu列表，做过滤使用
      parentMenuList: [] // 下拉menu的可选项
    }
  },
  created () {
    const _self = this;
    if (_self.query) {
      _self.fetchAllMenu(_self.fetchMenuMsg);
    } else {
      _self.formLoading = false;
      _self.fetchAllMenu();
    }
  },
  methods: {
    /**
     * 获取menu的详细信息
     */
    fetchMenuMsg () {
      const _self = this;
      _self.fetch('/sys/menu/info/' + _self.query).then(res => {
        _self.menuMsg = res.data;
        _self.postMenuFilter();
        _self.menuMsg.type = _self.menuMsg.type + '';
        _self.menuMsg.parentId = _self.menuMsg.parentId ? _self.menuMsg.parentId : '';
        _self.defaultMenu = JSON.parse(JSON.stringify(res.data));
        _self.formLoading = false;
      });
    },
    /**
     * 缓存全部的menu列表，做过滤使用
     * @param callback
     */
    fetchAllMenu (callback) {
      const _self = this;
      _self.fetch('/sys/menu/all').then(res => {
        _self.allMenuList = res.data.map(item => {
          return {
            value: item.menuId,
            label: item.name,
            type: item.type
          };
        });
        if (callback) callback();
      });
    },
    /**
     * icon修改
     **/
    updateIcon (name) {
      this.menuMsg.icon = name;
    },
    /**
     * 框架弹窗确认时被调用，必须方法
     * @returns {Promise<any>}
     */
    ok () {
      const _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs['editMenuForm'].validate((valid) => {
          if (valid) {
            let param = Object.compare(_self.defaultMenu, _self.menuMsg);
            delete param.parentName;

            // 如果未做任何修改，不发送请求
            if (Object.keys(param).length === 0) {
              resolve();
              return;
            }

            if (param.parentId === '') {
              param.parentId = '00000000000000000000000000000000';
            }
            if (_self.defaultMenu.menuId) {
              param.menuId = _self.defaultMenu.menuId;
            }
            _self.post('/sys/menu/saveOrUpdate', param).then(res => {
              resolve();
              this.cancel()
              this.$emit('refreshList');
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    },
    /**
     * 模糊查询过滤方法
     */
    postMenuFilter () {
      this.parentMenuLoading = false;
      this.parentMenuList = this.allMenuList.filter(item => item.type === Number(this.menuMsg.type - 1));
    },
    cancel () {
      this.showDialogs = false
      this.$emit('showDialogs', this.showDialogs)
    }
  }
}
</script>

<style lang='less'>
.menu-edit {
  .kh-form-item-content {
    display: flex !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/menuEditByCustom.vue